import type { Channel } from '@hilo/contracts';
import type { ReactNode } from 'react';
import styles from './ChannelMark.module.css';

/** Glifos propios (trazo blanco sobre el color de marca), reconocibles sin copiar los logotipos oficiales. */
const GLYPH: Record<Channel, ReactNode> = {
  WHATSAPP: (
    <>
      <path d="M4.2 19.8 5.3 16A8.2 8.2 0 1 1 8.4 19z" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinejoin="round" />
      <path fill="currentColor" d="M9.4 7.9c-.3 0-.6.1-.8.4-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.8 2.7 4.3 3.7 2.1.8 2.5.7 3 .6.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1-.1-.1-.2-.2-.5-.3l-1.6-.8c-.2-.1-.4-.1-.6.1l-.7.9c-.1.2-.3.2-.5.1-.3-.1-1-.4-1.9-1.2-.7-.6-1.1-1.3-1.3-1.6-.1-.2 0-.4.1-.5l.4-.4.2-.4c.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4z" />
    </>
  ),
  INSTAGRAM: (
    <g fill="none" stroke="currentColor" strokeWidth={1.9}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
      <circle cx="12" cy="12" r="3.9" />
      <circle cx="17" cy="7" r="0.6" fill="currentColor" />
    </g>
  ),
  MESSENGER: (
    <>
      <path d="M12 3.6c-4.8 0-8.5 3.5-8.5 8.1 0 2.5 1.1 4.6 2.9 6.1v3l2.8-1.5c.9.3 1.8.4 2.8.4 4.8 0 8.5-3.5 8.5-8.1S16.8 3.6 12 3.6z"
        fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinejoin="round" />
      <path d="m7.6 13.6 3-3.2 2.2 1.8 3.6-3.2-3 3.4-2.2-1.8z" fill="currentColor" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
    </>
  ),
};

/** Distintivo del canal (cuadro con su color de marca). Decorativo: el nombre del canal va en el texto. */
export function ChannelMark({ channel, size = 'md' }: { channel: Channel; size?: 'xs' | 'sm' | 'md' }) {
  return (
    <span className={`${styles.mark} ${styles[size]}`} data-channel={channel} aria-hidden="true">
      <svg viewBox="0 0 24 24" width="1em" height="1em" focusable="false">{GLYPH[channel]}</svg>
    </span>
  );
}
